<template>
  <div id="app">
    <!-- flash></flash -->
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMoment from 'vue-moment'
import $ from 'jquery'
import Flash from '@/components/Flash'

Vue.use(VueMoment)

Vue.filter('media', function(value, options) {
  options = options || {}
  const params = Object.keys(options)
    .reduce(function(params, key) {
      params.set(key, options[key])
      return params
    }, new URLSearchParams())
    .toString()

  return `${process.env.API}/media/${value}?${params}`
})

Vue.filter('certifications', function(value) {
  value = value || []
  if (value.length > 0) {
    value = value.join(', ')
    value = value.toUpperCase()
    return value
  } else {
    return 'Research use only'
  }
})

Vue.directive('tooltip', function(el, binding) {
  $(el).tooltip({
    title: binding.value,
    placement: binding.arg,
    trigger: 'hover'
  })
})

export default {
  name: 'app',
  components: { flash: Flash }
}
</script>
<style lang="scss">
  @import 'assets/color-theme/plugins/bootstrap3/css/bootstrap.css';
  @import 'assets/color-theme/plugins/font-awesome/css/font-awesome.css';
  @import 'assets/color-theme/plugins/animate/animate.css';
  @import 'assets/color-theme/css/e-commerce/style.css';
  @import 'assets/color-theme/css/e-commerce/style-responsive.css';
  @import 'assets/color-theme/css/e-commerce/theme/default.css';
  @import 'assets/color-theme/plugins/jquery-smart-wizard/src/css/smart_wizard.css';
  @import 'scss/_custom.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue